module.exports = __webpack_public_path__ + "static/mario-memory-game-eaa967c77c5fc012148fa740e419b633.jpg";